module.exports = __webpack_public_path__ + "static/landinglogo-28354c9f54d70b71234e85010c9010d7.png";